import { createSlice } from "@reduxjs/toolkit";
import instance from "api/globalaxios";

import { updateCase, updateCaseAnonymous } from "./casesSlice";
import { gethost } from "./disputeSlice";

export const initialState = {
  loading: false,
  hasErrors: false,
  answers: [],
};

const answerSlice = createSlice({
  name: "answers",
  initialState,
  reducers: {
    setProgress: (state) => {
      state.loading = true;
    },
    setSucessfull: (state, { payload }) => {
      state.answers = payload.results;
      state.loading = false;
      state.hasErrors = false;
    },
    setError: (state) => {
      state.loading = false;
      state.hasErrors = true;
    },
  },
});

export const { setProgress, setSucessfull, setError } = answerSlice.actions;
export default answerSlice.reducer;

export function getAnswers(caseid) {
  console.log("In Answers fetch");
  return async (dispatch) => {
    dispatch(setProgress());
    try {
      let response = await instance({
        method: "get",
        url: "/api/answer/",
        params: {
          case__id: caseid,
          host: gethost(),
        },
      });

      console.log(response.data);
      dispatch(setSucessfull(response.data));
      return response.data;
    } catch (error) {
      console.log(error);
      // console.log(error.request.status);
      // console.log(error.message)
      // console.log(error.request.response)
      dispatch(setError);
    }
  };
}

export function getAnswersAnonymous(caseid, email, phone) {
  console.log("In Answers fetch");
  return async (dispatch) => {
    dispatch(setProgress());
    try {
      let response = await instance({
        method: "get",
        url: "/api/anonymousanswer/",
        params: {
          case__id: caseid,
          email: email,
          host: gethost(),
          phone,
        },
      });

      console.log(response.data);
      dispatch(setSucessfull(response.data));
      return response.data;
    } catch (error) {
      console.log(error);
      // console.log(error.request.status);
      // console.log(error.message)
      // console.log(error.request.response)
      dispatch(setError);
    }
  };
}

export function createAnswersAnonymous(
  { createAnswerPayload, casePayload },
  email,
  phone,
) {
  return async (dispatch) => {
    dispatch(setProgress());
    try {
      let response = await instance({
        method: "post",
        url: "/api/anonymousanswer/" + "?host=" + gethost(),
        data: createAnswerPayload,
        params: {
          email: email,
          phone,
        },
      });
      console.log(response.data);
      dispatch(setSucessfull(response.data));
      if(casePayload){
        dispatch(updateCaseAnonymous(casePayload, email, phone));
      }
    } catch (error) {
      console.log(error);
      dispatch(setError());
    }
  };
}

export function createAnswers({ createAnswerPayload, casePayload }) {
  return async (dispatch) => {
    dispatch(setProgress());
    try {
      let response = await instance({
        method: "post",
        url: "/api/answer/" + "?host=" + gethost(),
        data: createAnswerPayload,
      });
      console.log(response.data);
      dispatch(setSucessfull(response.data));
      if(casePayload){
        dispatch(updateCase(casePayload));
      }
    } catch (error) {
      console.log(error);
      dispatch(setError());
    }
  };
}

export function editAnswer({ question, answerId, answer, caseId }) {
  console.log(question, answerId, answer, caseId);
  return async (dispatch) => {
    try {
      let response = await instance({
        method: "put",
        url: `/api/answer/${answerId}/` + "?host=" + gethost(),
        data: { question, value: answer, case: caseId },
      });
      console.log(response.data);
      // dispatch(setSucessfull(response.data));
    } catch (error) {
      console.log(error.request.status);
      console.log(error.message);
      // console.log(error.request.response);
    }
  };
}

export function editAnswerAnonymous(
  { question, answerId, answer, caseId },
  email,
  phone,
) {
  console.log(question, answerId, answer, caseId);
  return async (dispatch) => {
    try {
      let response = await instance({
        method: "put",
        url: `/api/anonymousanswer/${answerId}/`,
        data: { question, value: answer, case: caseId },
        params: {
          email: email,
          host: gethost(),
          phone,
        },
      });
      console.log(response.data);
      // dispatch(setSucessfull(response.data));
    } catch (error) {
      console.log(error.request.status);
      console.log(error.message);
      // console.log(error.request.response);
    }
  };
}

export function editAnswersInBluk({ createAnswerPayload, casePayload }) {
  return async (dispatch) => {
    dispatch(setProgress());
    try {
      let response = await instance({
        method: "patch",
        url: "/api/answer/bulk-update/" + "?host=" + gethost(),
        data: createAnswerPayload,
      });
      dispatch(setSucessfull(response.data));
      if(casePayload){
        dispatch(updateCase(casePayload));
      }
    } catch (error) {
      console.log(error);
      dispatch(setError());
    }
  };
}

export function editAnswersInBlukAnonymous({ createAnswerPayload, casePayload }, email) {
  return async (dispatch) => {
    dispatch(setProgress());
    try {
      let response = await instance({
        method: "patch",
        url: "/api/anonymousanswer/bulk-update/",
        data: createAnswerPayload,
        params: {
          email: email,
          host: gethost(),
        },
      });
      dispatch(setSucessfull(response.data));
      if(casePayload){
        dispatch(updateCaseAnonymous(casePayload, email));
      }
    } catch (error) {
      console.log(error);
      dispatch(setError());
    }
  };
}
